import { Link } from 'react-router-dom';

export default function SubmitCta() {
  return (
    <section aria-labelledby="cta-title" className="w-full px-4 md:px-6 lg:px-10 py-14 md:py-20 bg-background-50">
      <div className="relative overflow-hidden rounded-lg bg-primary-600 px-6 py-10 md:px-12 md:py-14">
        <div className="relative w-full flex flex-col lg:flex-row lg:items-center lg:justify-between gap-8">
          <div className="max-w-2xl">
            <span className="inline-flex items-center gap-2 rounded-full border border-background-50/30 px-3 py-1 font-label text-xs text-background-50">
              <i className="ri-share-forward-line" aria-hidden="true"></i>
              收录申请 · 三到五个工作日审核
            </span>
            <h2 id="cta-title" className="mt-4 font-heading text-2xl md:text-3xl font-bold text-background-50">
              有好用的站点没被收录？告诉我们
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-background-50/85">
              只要内容合规、能稳定访问，并且属于已开设的分类方向，都欢迎提交。收录不收取任何费用，也不提供付费置顶。
            </p>
          </div>
          <div className="flex flex-col sm:flex-row gap-3 shrink-0">
            <Link
              to="/submit"
              className="inline-flex items-center justify-center gap-2 h-12 px-6 rounded-md bg-accent-500 text-accent-950 font-label text-sm whitespace-nowrap hover:bg-accent-400 transition-colors"
            >
              <i className="ri-add-circle-line" aria-hidden="true"></i>
              提交站点收录
            </Link>
            <Link
              to="/about"
              className="inline-flex items-center justify-center gap-2 h-12 px-6 rounded-md border border-background-50/40 text-background-50 font-label text-sm whitespace-nowrap hover:bg-background-50/10 transition-colors"
            >
              了解收录标准
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}